import Head from 'next/head'
import React from 'react'

interface OrganizationSchemaProps {
  path: string
}

const OrganizationSchema: React.FC<OrganizationSchemaProps> = ({ path }) => {
  if (path === '' || path === 'home') {
    const schemaData = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: process.env.NEXT_PUBLIC_ORG_NAME,
      url: process.env.NEXT_PUBLIC_ORG_URL,
      logo: process.env.NEXT_PUBLIC_ORG_LOGO,
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: process.env.NEXT_PUBLIC_ORG_PHONE,
        contactType: process.env.NEXT_PUBLIC_ORG_CONTACT_TYPE,
        availableLanguage: process.env.NEXT_PUBLIC_ORG_LANGUAGE,
      },
      sameAs: [
        'https://www.linkedin.com/company/cynergy-bank',
        'https://x.com/CynergyBank',
      ],
    }

    return (
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
      </Head>
    )
  }
  return null
}

export default OrganizationSchema
